import React, { useEffect, useState } from "react"
import { aHasPlayed, aIsPlaying, useAtomValue } from "~/atoms"
import { cn } from "~/utils"
import { PauseIcon, PlayIcon } from "./icons"

function Container({
  className,
  children,
}: {
  className?: string
  children: React.ReactNode
}) {
  return (
    <div
      className={cn(
        "pointer-events-none absolute inset-1/2 z-10 flex size-16 -translate-x-1/2 -translate-y-1/2 transform items-center justify-center rounded-full bg-black/75 md:size-28",
        className
      )}
    >
      {children}
    </div>
  )
}

export default function LargePlayControl({
  className,
  isAtEnd = false,
}: {
  className?: string
  isAtEnd: boolean
}) {
  const hasPlayed = useAtomValue(aHasPlayed)
  const isPlaying = useAtomValue(aIsPlaying)
  const [previousHasPlayed, setPreviousHasPlayed] = useState<boolean | null>(
    null
  )
  const [showPlayPause, setShowPlayPause] = useState(false)

  useEffect(() => {
    if (hasPlayed && previousHasPlayed === null) {
      setPreviousHasPlayed(isPlaying)
    }
  }, [isPlaying, hasPlayed, previousHasPlayed])

  useEffect(() => {
    if (previousHasPlayed !== null && previousHasPlayed !== isPlaying) {
      setPreviousHasPlayed(isPlaying)
      setShowPlayPause(true)
      setTimeout(() => setShowPlayPause(false), 800)
    }
  }, [previousHasPlayed, isPlaying])

  if (!hasPlayed || isAtEnd) {
    return (
      <Container className={className}>
        <PlayIcon className="size-8 text-white md:size-12" />
      </Container>
    )
  } else if (showPlayPause) {
    return (
      <Container className={cn("fade-in-out", className)}>
        {isPlaying ? (
          <PlayIcon className="size-8 text-white md:size-12" />
        ) : (
          <PauseIcon className="size-8 text-white md:size-12" />
        )}
      </Container>
    )
  }

  return null
}
